var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-xs mt-1 ml-2 font-bold"},[(_vm.note === null || _vm.note === '')?_c('div',[_vm._v("   ")]):_c('div',[_vm._v(" "+_vm._s(_vm.note)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }